module.exports = __webpack_public_path__ + "img/MED_RED_MEATS@300x.607318ec.png";